<template>
  <div>
    <travel-service-menu />

    <h3>{{ $t("settings.travelService.configureEmailSubject") }}</h3>

    {{ $t("settings.travelService.availableTagsList") }}<br />

    <b>{STANDARD}</b> - {{ $t("settings.travelService.availableTag.standard") }} <br />
    <b>{ID}</b> - {{ $t("settings.travelService.availableTag.id") }} <br />

    <b>{CREATED_AT}</b> - {{ $t("settings.travelService.availableTag.createdAt") }} <br />
    <b>{CREATED_BY}</b> - {{ $t("settings.travelService.availableTag.createdBy") }} <br />

    <b>{PRICE}</b> - {{ $t("settings.travelService.availableTag.price") }}
    <br />

    {ATTRIBUTE:[<span style="text-decoration: #0f0f0f line-through">example</span>]} - {{ $t("settings.travelService.availableTag.customAttribute") }}<br />

    <span v-for="parameter in additionalParameters" :key="parameter.id">
      <b>{ATTRIBUTE:[{{ parameter.name }}]}</b> <br />
    </span>

    <v-text-field v-model="subjectMask"> </v-text-field>
    <v-row class="mb-4">
      <v-spacer />
      <v-btn :disabled="$store.getters['Ajax/loading']" @click="saveCurrentCustomSubject" color="success" class="mr-3">{{ $t("global.save") }}</v-btn>
    </v-row>

    <v-alert :value="subjectMask == null || subjectMask.length === 0" color="info" icon="info" dark>
      {{ $t("settings.travelService.standardSubjectAlert") }}
    </v-alert>
  </div>
</template>

<script>
import TravelServiceMenu from "../../../components/Settings/TravelService/TravelServiceMenu";

export default {
  name: "SettingsTravelServiceMailSubjectView",
  components: { TravelServiceMenu },
  data: () => ({
    subjectMask: null,
    additionalParameters: []
  }),
  computed: {},
  created() {
    this.downloadParamList();
    this.downloadCurrentCustomSubject();
  },
  methods: {
    downloadParamList() {
      this.axios.get("/settings/travel-service/get-additional-parameters").then(resp => {
        this.additionalParameters = resp.data;
      });
    },
    downloadCurrentCustomSubject() {
      this.axios.get("/settings/travel-service/get-custom-subject").then(resp => {
        this.subjectMask = resp.data.travel_service_subject_mask;
      });
    },
    saveCurrentCustomSubject() {
      this.axios
        .post("/settings/travel-service/save-custom-subject", {
          travel_service_subject_mask: this.subjectMask
        })
        .then(() => {
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved"),
            position: "down"
          });
        });
    }
  }
};
</script>

<style scoped></style>
